import api from '../api'; // Assuming 'api' is your configured Axios instance

/**
 * Send a coupon to be created on the server.
 *
 * @param {Object} coupon - The coupon to create.
 * @return {Promise<Object>} - The response from the API.
 * @throws {Error} - If the request fails.
 */
const setCoupon = async (coupon) => {
  // Define your API endpoint
  const endpoint = process.env.REACT_APP_API_ENDPOINT + "/api/coupon/set";

  try {
    // Send POST request to the server
    const response = await api.post(endpoint, coupon);

    // Check the response code from API and throw error if it's not SUCCESS
    if (response.data.code !== '000') {
      throw new Error('Failed to set coupon: ' + response.data.message);
    }

    // Return the data from the response
    return response.data;

  } catch (error) {
    // Log and rethrow the error to be handled by the calling code
    console.error('Error while setting coupon:', error);
    throw error;
  }
};

export default setCoupon;
